import React from "react";
import { Map } from "@mui/icons-material";

import MapProvider from "fond/map/MapProvider";
import { BBox } from "fond/types/geometry";
import { Modal } from "fond/widgets";

import { GeoReferencerProvider } from "./GeoReferencerContext";
import GeoReferencerWizard from "./GeoReferencerWizard";

export interface GeoReferencerResult {
  imageName: string;
  imageUrl: string;
  imageCorners: [[number, number], [number, number], [number, number], [number, number]];
  opacity: number;
}

interface GeoReferencerModalProps {
  open: boolean;
  bbox?: BBox | null;
  onClose: () => void;
  onConfirm: (data: GeoReferencerResult) => void;
}

const GeoReferencerModal: React.FC<GeoReferencerModalProps> = ({ open, bbox, onClose, onConfirm }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      fullscreen
      showClose
      variant="secondary"
      header="Georeference Image"
      headerSubtitle="Align the image with the map by specifying its corners"
      headerIcon={<Map />}
      DialogContentProps={{ style: { display: "flex", flex: 1, padding: 0, overflow: "hidden" } }}
      DialogActionsProps={{ style: { display: "none" } }}
      content={
        open ? (
          <GeoReferencerProvider>
            <MapProvider>
              <GeoReferencerWizard bbox={bbox} onClose={onClose} onConfirm={onConfirm} />
            </MapProvider>
          </GeoReferencerProvider>
        ) : undefined
      }
    />
  );
};

export default GeoReferencerModal;
